import { motion } from 'framer-motion';
import { useState } from 'react';
import { Reveal } from '../../ui/Reveal/Reveal';
import { showcase } from '../../../data/showcase';
import './Showcase.css';

export function Showcase() {
  const [hover, setHover] = useState<string | null>(null);

  return (
    <section id="showcase" className="section showcase">
      <div className="container">
        <div className="showcase__head">
          <Reveal>
            <span className="eyebrow">Selected Work</span>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="showcase__title display-lg">
              Productions, recently<br />
              <span className="italic-accent">delivered.</span>
            </h2>
          </Reveal>
        </div>

        <div className="showcase__list">
          {showcase.map((item, i) => (
            <Reveal key={item.id} delay={i * 0.04}>
              <a
                href={`#${item.id}`}
                className="showcase__row"
                onMouseEnter={() => setHover(item.id)}
                onMouseLeave={() => setHover(null)}
                data-cursor="hover"
              >
                <span className="showcase__year">{item.year}</span>
                <span className="showcase__name">
                  <span className="showcase__name-inner">{item.title}</span>
                </span>
                <span className="showcase__cat">{item.category}</span>
                <span className="showcase__loc">{item.location}</span>

                <motion.div
                  className="showcase__preview"
                  animate={{
                    opacity: hover === item.id ? 1 : 0,
                    scale: hover === item.id ? 1 : 0.85,
                  }}
                  transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                >
                  <img src={item.image} alt={item.title} loading="lazy" />
                </motion.div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
